<template>
	<div class="container">
		<div class="content">
			<h3 class="title">您想发起的大学生公益活动信息</h3>
			<el-form :model="formInfo" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="本单位名称" prop="companyName">
					<el-input clearable placeholder="请输入单位名称" v-model="formInfo.companyName"></el-input>
				</el-form-item>
				<el-form-item label="联系人姓名" prop="userName">
					<el-input clearable placeholder="请输入联系人姓名" v-model="formInfo.userName"></el-input>
				</el-form-item>
				<el-form-item label="联系人电话" prop="phone">
					<el-input clearable placeholder="请输入联系人电话" v-model="formInfo.phone"></el-input>
				</el-form-item>
				<el-form-item label-width="200" label="拟发起的活动简介" prop="content">
					<el-input clearable :rows="6" placeholder="请描述：想招募多少名大学生去完成什么任务" type="textarea" v-model="formInfo.content"></el-input>
				</el-form-item>
			</el-form>
			<div class="button-single" @click="submitInfo">
				<span>提 交</span>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'ActivitySubmit',
		components: {
			
		},
		data(){
			return {
				formInfo: {
					companyName: '', //单位名称
					userName: '',
					phone: '',
					content: ''
				},
				rules: {
					companyName: [
						{ required: true, message: '请输入单位名称', trigger: 'blur' }
					],
					userName: [
						{ required: true, message: '请输入联系人姓名', trigger: 'blur' }
					],
					phone: [
						{ required: true, message: '请输入联系人电话', trigger: 'blur' }
					],
					content: [
						{ required: true, message: '请输入描述', trigger: 'blur' }
					]
				}
			}
		},
		created(){
			
		},
		methods: {
			//提交信息
			async submitInfo(){
				if(this.formInfo.companyName==''){
					this.$message.error('请输入单位名称')
					return
				}
				if(this.formInfo.userName==''){
					this.$message.error('请输入联系人姓名')
					return
				}
				if(this.formInfo.phone==''){
					this.$message.error('请输入联系人电话')
					return
				}
				if(this.formInfo.content==''){
					this.$message.error('请输入活动描述')
					return
				}
				let param = this.formInfo
				ajaxParam(param)
				const res = await post('website/vacation/vacationSubmit', qs.stringify(param))
				if(res.data.code==200){
					this.$message.success('您的信息提交成功！')
					this.formInfo.companyName = ''
					this.formInfo.userName = ''
					this.formInfo.phone = ''
					this.formInfo.content = ''
					
				} else {
					this.$message.error(res.data.msg)
				}
			},
		}
	}
</script>

<style scoped lang="less">
	/deep/ .el-form-item:last-of-type{
		display: flex;
		flex-direction: column;
		.el-form-item__label{
			text-align: left;
		}
	}
	.content{
		width: 760px;
		margin-left: auto;
		margin-right: auto;
		.title{
			padding: 10px 0 20px;
		}
	}
	
</style>
